import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MessageTemplateStatusForm from '../../../components/forms/MessageTemplateStatusForm';
import { useMessageTemplateStatusApi } from '../../../hooks/useMessageTemplateStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MessageTemplateStatusDTO } from '../../../services/apiClient';

const MessageTemplateStatusCreate: React.FC = () => {
  const { create, isLoading } = useMessageTemplateStatusApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    {
      label: 'Message Template Statuses',
      href: '/admin/messagetemplatestatuses',
    },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MessageTemplateStatusDTO) => {
    try {
      await create(data);
      navigate('/admin/messagetemplatestatuses');
    } catch (error) {
      console.error('Error creating MessageTemplateStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/messagetemplatestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MessageTemplateStatus.Edit"
    >
        <MessageTemplateStatusForm
          initialValues={{} as MessageTemplateStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/messagetemplatestatuses')}
        />
    </AdminLayout>
  );
};

export default MessageTemplateStatusCreate;
